// extracted by mini-css-extract-plugin
export var container = "imageCard-module--container--8aMRK";
export var fade = "imageCard-module--fade--0en2+";
export var imageContainer = "imageCard-module--imageContainer--JBcak";
export var content = "imageCard-module--content--E-ecO";
export var textContainer = "imageCard-module--textContainer--TTC8N";
export var title = "imageCard-module--title--3xxVY";
export var tag = "imageCard-module--tag--2XQOq";
export var linkContainer = "imageCard-module--linkContainer--9Eds5";
export var link = "imageCard-module--link--cmpCc";